// Polish (pl) — EU MDR submission language.
// Covers the visitor-facing eIFU portal strings only; the admin console is not
// localized. Missing keys fall back to English (see src/i18n.js).
const pl = {
  'show all manuals': 'pokaż wszystkie instrukcje',
  eifuPortalIntro:
    'Przeglądaj i pobieraj elektroniczne instrukcje używania (eIFU) oprogramowania wyrobów medycznych RAY.',
  'Checking the latest documents.': 'Sprawdzanie najnowszych dokumentów.',
  'There are no manuals to display.': 'Brak instrukcji do wyświetlenia.',
  Manuals: 'Instrukcje',
  'Product Name': 'Nazwa produktu',
  Language: 'Język',
  'Document Name': 'Nazwa dokumentu',
  Product: 'Produkt',
  Revision: 'Wersja',
  Document: 'Dokument',
  Published: 'Opublikowano',
  Country: 'Kraj',
  'All countries': 'Wszystkie kraje',
  Search: 'Szukaj',
  'No results': 'Brak wyników',
  'appManuals.downloadHelpText':
    'Pobrane pliki można przeglądać w przeglądarce internetowej lub w programie do odczytu plików PDF.',
  'appManuals.systemRequirements':
    'Wymagania systemowe: procesor Intel® Core™ i3 lub nowszy, co najmniej 4 GB pamięci, co najmniej 100 MB wolnego miejsca na zapisanie pliku PDF.',
  'criticalNotice.badge': 'Ważna informacja',
  'criticalNotice.close': 'Zamknij',
};

export default pl;
